export default __webpack_public_path__ + "static/media/ic20-warning.652b5670.svg";